import Vue from 'vue'
import App from './App.vue'
import store from '@/store/root'
import router from './router'
import './plugins/element.js'
import './plugins/vuedatatable.js'
import './plugins/vueantdesign.js'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import 'firebase/messaging'
import 'firebase/database'

import Dayjs from 'vue-dayjs'
import VueCurrencyFilter from 'vue-currency-filter'
import MixinOrderUtility from '@/mixins/orderUtility.js'
import MixinShopUtility from '@/mixins/shopUtility.js'
import MixinShipflowUtility from '@/mixins/shipflowUtility.js'
import { serverConfig } from '@/config/serverConfig.js'
import 'vue-awesome/icons/flag'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueOffline from 'vue-offline'
import th from 'vee-validate/dist/locale/th'
import VeeValidate, { Validator } from 'vee-validate'
import Vuelidate from 'vuelidate'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import './quasar'
import CKEditor from '@ckeditor/ckeditor5-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import { vueAppSelMode } from '@/config'

Vue.use(CKEditor)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
export const eventBus = new Vue({})
Vue.component('RecycleScroller', RecycleScroller)
const config = {
    inject: false,
    delay: 500
}

Vue.use(VeeValidate, config)
Validator.localize('th', th)
Vue.use(VueOffline)
Vue.use(Dayjs)
Vue.use(VueCurrencyFilter, {
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'back',
    symbolSpacing: true
})
Vue.mixin(MixinOrderUtility)
Vue.mixin(MixinShopUtility)
Vue.mixin(MixinShipflowUtility)

Vue.component('fa-icon', Icon)
Vue.config.productionTip = false

firebase.initializeApp(serverConfig.firebaseConfig)
const firebaseDev = firebase.initializeApp(serverConfig.firebaseFillgoods.dev, 'FgDev')
const firebaseUat = firebase.initializeApp(serverConfig.firebaseFillgoods.uat, 'FgUat')
const firebaseProd = firebase.initializeApp(serverConfig.firebaseFillgoods.prod, 'FgProd')
const firebaseOms = firebase.initializeApp(serverConfig.firebaseFillgoods.oms, 'FgOms')
const firebaseOmsDev = firebase.initializeApp(serverConfig.firebaseFillgoods.omsDev, 'FgOmsDev')

let appMainVue

firebase.auth().onAuthStateChanged(() => {
    if (!appMainVue) {
        appMainVue = new Vue({
            el: '#app',
            router,
            store,
            created () {
                this.$store.set('fgFirbaseApp/dev', firebaseDev)
                this.$store.set('fgFirbaseApp/uat', firebaseUat)
                this.$store.set('fgFirbaseApp/prod', firebaseProd)
                this.$store.set('fgFirbaseApp/oms', firebaseOms)
                this.$store.set('fgFirbaseApp/omsDev', firebaseOmsDev)
                if (vueAppSelMode) {
                    this.$store.set('envSystem/mode', vueAppSelMode)
                }
            },
            components: {
                App
            },
            template: '<App/>',
            render: h => h(App)
        })
    }
})
